import ScrollToTop from '@mborecki/react-scroll-to-top';
import React from 'react';
import { BrowserRouter, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import DevTools from './components/dev-tools';
import useConfig from './modules/main/hooks/use-config';
import useIsLogged from './modules/user/hooks/use-is-logged';
import AddLibraryPage from './routes/admin/add-library';
import AdminLoginPage from './routes/admin/login';
import AdminMainPage from './routes/admin/main';
import EditLibraryPage from './routes/edit-library';
import EndPage from './routes/end';

import HomePage from './routes/home';
import LandingPage from './routes/landing-page';
import LibraryListPage from './routes/admin/library-list';
import LoginPage from './routes/login';
import MapPage from './routes/map';
import { getAddLibraryRoute, getAdminLoginRoute, getAdminMainRoute, getEditLibraryRoute, getEndRoute, getHomeRoute, getLandingPageRoute, getLibraryListRoute, getLoginRoute, getMapRoute, getRulesRoute, getTaskRoute, getWelcomeRoute } from './routes/routes';
import RulesPage from './routes/rules';
import TaskPage from './routes/task';
import WelcomePage from './routes/welcome';
import useGTag from './modules/gtag/hooks/use-gtag';

export default function App() {
    const { isAdmin } = useConfig();

    return (
        <div className='main-container'>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Routes />
                {isAdmin && <DevTools />}
            </BrowserRouter >
        </div>
    )
}

const OnlyForLoggedRoute: React.FC<any> = ({ children, ...rest }: any) => {

    const { isLogged } = useIsLogged();

    return <Route {...rest}>{
        isLogged
            ? children
            : <Redirect to={getLoginRoute()} />
    } </Route>
}

const OnlyForUnloggedRoute = ({ children, ...rest }: any) => {

    const { isLogged } = useIsLogged();

    return <Route {...rest}>{
        isLogged
            ? <Redirect to={getWelcomeRoute()} />
            : children
    } </Route>
}

const OnlyForAdminRoute: React.FC<any> = ({ children, ...rest }: any) => {

    const { isAdmin } = useConfig();

    return <Route {...rest}>{
        isAdmin
            ? children
            : <Redirect to={getAdminLoginRoute()} />
    } </Route>
}

const OnlyForNotAdminRoute = ({ children, ...rest }: any) => {

    const { isAdmin } = useConfig();

    return <Route {...rest}>{
        isAdmin
            ? <Redirect to={getAdminMainRoute()} />
            : children
    } </Route>
}

const Routes: React.FC<{}> = () => {
    const { pathname } = useLocation();
    useGTag();

    return <>
        <ScrollToTop trigger={pathname} />
        <Switch>
            <Route path={getHomeRoute()} component={HomePage} exact />

            <OnlyForUnloggedRoute path={getLoginRoute()} exact>
                <LoginPage />
            </OnlyForUnloggedRoute>

            <OnlyForLoggedRoute path={getWelcomeRoute()}>
                <WelcomePage />
            </OnlyForLoggedRoute>

            <Route path={getRulesRoute()}>
                <RulesPage />
            </Route>

            <OnlyForLoggedRoute path={getMapRoute()}>
                <MapPage />
            </OnlyForLoggedRoute>

            <OnlyForLoggedRoute path={getTaskRoute()}>
                <TaskPage />
            </OnlyForLoggedRoute>

            <OnlyForLoggedRoute path={getEndRoute()}>
                <EndPage />
            </OnlyForLoggedRoute>

            <OnlyForNotAdminRoute path={getAdminLoginRoute()} exact>
                <AdminLoginPage />
            </OnlyForNotAdminRoute>

            <OnlyForAdminRoute path={getAddLibraryRoute()} exact>
                <AddLibraryPage />
            </OnlyForAdminRoute>

            <OnlyForAdminRoute path={getLibraryListRoute()} exact>
                <LibraryListPage />
            </OnlyForAdminRoute>

            <Route component={EditLibraryPage} path={getEditLibraryRoute()} exact />

            <OnlyForAdminRoute path={getAdminMainRoute()} exact>
                <AdminMainPage />
            </OnlyForAdminRoute>

            <Route component={LandingPage} path={getLandingPageRoute()} exact />

            <Route component={HomePage} />
        </Switch>
    </>
}
